"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "moncucco-torinese": {
    "6736ac93": [{
      "hkey": "3119c381",
      "slug": "moncucco-torinese",
      "name": "Moncucco Torinese",
      "primary": true,
      "skipSearch": false
    }],
    "roasine": [{
      "hkey": "3119c381",
      "slug": "moncucco-torinese",
      "name": "Moncucco Torinese",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "c3fa16c7": [{
      "hkey": "3119c381",
      "slug": "moncucco-torinese",
      "name": "Moncucco Torinese",
      "primary": true,
      "skipSearch": false
    }],
    "san-giorgio": [{
      "hkey": "3119c381",
      "slug": "moncucco-torinese",
      "name": "Moncucco Torinese",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "c7548247": [{
      "hkey": "3119c381",
      "slug": "moncucco-torinese",
      "name": "Moncucco Torinese",
      "primary": true,
      "skipSearch": false
    }],
    "san-paolo": [{
      "hkey": "3119c381",
      "slug": "moncucco-torinese",
      "name": "Moncucco Torinese",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;